/* SMAEL — menu do celular (10 modelos). Veja snippets/smael-menu.liquid e assets/smael-menu.css.
   - Só atua em telas até 749px. Modelo 0 = menu original do tema (não intercepta nada).
   - O modelo escolhido fica no aparelho (localStorage 'smael-menu-m'); padrão = 1.
   - ?menu=1 no endereço mostra o painel de teste (trocar de modelo ao vivo); ?menu=0 esconde. */
(function () {
  var KEY = 'smael-menu-m', LABKEY = 'smael-menu-lab', DEFAULT = 1, TOTAL = 10;
  var NOMES = ['Original do tema', 'Lateral clássico', 'Tela cheia', 'Gaveta de baixo', 'Atalhos em grade', 'Abas', 'Coleções com foto', 'Produtos em destaque', 'Painel compacto', 'Lateral direita + conta', 'Camadas'];
  var mq = window.matchMedia('(max-width: 749px)');
  var root, panelCloseTimer, lastFocus, startedFromHamburger;

  function lerModelo() {
    try { var v = parseInt(localStorage.getItem(KEY), 10); if (v >= 0 && v <= TOTAL) return v; } catch (e) {}
    return DEFAULT;
  }
  function gravarModelo(v) { try { localStorage.setItem(KEY, String(v)); } catch (e) {} }

  function el() { return root || (root = document.querySelector('[data-smm]')); }
  function aberto() { var r = el(); return !!(r && r.classList.contains('is-open')); }

  function fecharMenuOriginal() {
    var d = document.getElementById('Details-menu-drawer-container');
    if (d && d.hasAttribute('open')) { var s = d.querySelector('summary'); if (s) { try { s.click(); } catch (e) {} } }
  }

  function abrir() {
    var r = el(); if (!r || aberto()) return;
    var v = lerModelo(); if (v === 0) return;
    lastFocus = document.activeElement;
    clearTimeout(panelCloseTimer);
    r.setAttribute('data-v', String(v));
    irPara('root');
    r.hidden = false;
    document.documentElement.classList.add('smm-open');
    void r.offsetWidth;                                   // um quadro com o painel fora da tela, depois anima só com transform
    r.classList.add('is-open');
    var btn = r.querySelector('.smm__close'); if (btn) { try { btn.focus({ preventScroll: true }); } catch (e) {} }
  }

  function fechar() {
    var r = el(); if (!r || !aberto()) return;
    r.classList.remove('is-open');
    document.documentElement.classList.remove('smm-open');
    clearTimeout(panelCloseTimer);
    panelCloseTimer = setTimeout(function () { r.hidden = true; }, 240);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  var TITULOS = { root: 'Menu', shop: 'Shop', help: 'Help', acct: 'Account', menu: 'Menu' };
  function irPara(painel) {
    var r = el(); if (!r) return;
    var v = r.getAttribute('data-v');
    if (v === '5') painel = painel === 'menu' ? 'root' : painel;
    r.setAttribute('data-pane', painel);
    var t = r.querySelector('[data-smm-title]'); if (t) t.textContent = TITULOS[painel] || 'Menu';
    r.querySelectorAll('[data-tab]').forEach(function (b) {
      var alvo = b.getAttribute('data-tab'); alvo = alvo === 'menu' ? 'root' : alvo;
      b.setAttribute('aria-selected', alvo === painel ? 'true' : 'false');
    });
    var body = r.querySelector('.smm__body'); if (body) body.scrollTop = 0;
  }

  /* interceptar o botão ☰ original (fase de captura, só no celular, só se o modelo != 0) */
  function interceptar(e) {
    if (!mq.matches || lerModelo() === 0 || !el()) return;
    var s = e.target.closest && e.target.closest('#Details-menu-drawer-container > summary, header-drawer summary.header__icon--menu');
    if (!s) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    fecharMenuOriginal();
    if (aberto()) fechar(); else abrir();
  }
  window.addEventListener('click', interceptar, true);

  document.addEventListener('click', function (e) {
    var r = el(); if (!r) return;
    var t = e.target;
    if (!t.closest) return;
    var c = t.closest('[data-smm-close]'); if (c && r.contains(c)) { e.preventDefault(); fechar(); return; }
    var go = t.closest('[data-smm-go]'); if (go && r.contains(go)) { irPara(go.getAttribute('data-smm-go')); return; }
    var bk = t.closest('[data-smm-back]'); if (bk && r.contains(bk)) { irPara('root'); return; }
    var tab = t.closest('[data-tab]'); if (tab && r.contains(tab)) { irPara(tab.getAttribute('data-tab') === 'menu' ? 'root' : tab.getAttribute('data-tab')); return; }
    var th = t.closest('[data-smm-tema]'); if (th && r.contains(th)) { definirTema(th.getAttribute('data-smm-tema')); return; }
    var a = t.closest('a[href]'); if (a && r.contains(a) && aberto()) { setTimeout(fechar, 50); }   // navegação normal; fecha para não ficar aberto ao voltar (bfcache)
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && aberto()) { fechar(); } });
  function sair() { if (!mq.matches && aberto()) fechar(); }
  if (mq.addEventListener) mq.addEventListener('change', sair); else if (mq.addListener) mq.addListener(sair);
  window.addEventListener('pageshow', function () { var r = el(); if (r && aberto()) { r.classList.remove('is-open'); r.hidden = true; document.documentElement.classList.remove('smm-open'); } });

  function definirTema(t) {
    if (window.SmaelTema && window.SmaelTema.definir) window.SmaelTema.definir(t);
    else { document.documentElement.setAttribute('data-smael-tema', t); try { localStorage.setItem('smael-tema', t); } catch (e) {} }
  }

  /* painel de teste */
  function labLigado() {
    var m = /[?&]menu=([01])/.exec(location.search);
    if (m) { try { localStorage.setItem(LABKEY, m[1]); } catch (e) {} return m[1] === '1'; }
    try { return localStorage.getItem(LABKEY) === '1'; } catch (e) { return false; }
  }
  function montarLab() {
    if (!labLigado() || document.querySelector('.smm-lab')) return;
    var box = document.createElement('div'); box.className = 'smm-lab';
    var p = document.createElement('p'); p.textContent = 'Teste de menus do celular — escolha o modelo e toque em ☰ (ou em "Abrir menu"):'; box.appendChild(p);
    var row = document.createElement('div'); row.className = 'smm-lab__row'; box.appendChild(row);
    function marcar() { var cur = lerModelo(); row.querySelectorAll('[data-m]').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.getAttribute('data-m'), 10) === cur)); }); }
    for (var i = 0; i <= TOTAL; i++) {
      (function (n) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-m', String(n));
        b.textContent = n === 0 ? '0 · Original' : n + ' · ' + NOMES[n];
        b.addEventListener('click', function () {
          var estavaAberto = aberto();
          if (estavaAberto) { var r = el(); r.classList.remove('is-open'); r.hidden = true; document.documentElement.classList.remove('smm-open'); }
          gravarModelo(n); marcar();
          if (n === 0) fecharMenuOriginal(); else if (estavaAberto) abrir();
        });
        row.appendChild(b);
      })(i);
    }
    var abre = document.createElement('button'); abre.type = 'button'; abre.className = 'smm-lab__abrir'; abre.textContent = 'Abrir menu';
    abre.addEventListener('click', function () { if (lerModelo() === 0) { var s = document.querySelector('#Details-menu-drawer-container > summary'); if (s) s.click(); } else abrir(); });
    var x = document.createElement('button'); x.type = 'button'; x.className = 'smm-lab__x'; x.textContent = '✕ esconder';
    x.addEventListener('click', function () { try { localStorage.setItem(LABKEY, '0'); } catch (e) {} box.remove(); });
    row.appendChild(abre); row.appendChild(x);
    marcar();
    document.body.appendChild(box);
  }

  window.SmaelMenu = { abrir: abrir, fechar: fechar, modelo: lerModelo, definirModelo: function (n) { gravarModelo(n); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', montarLab); else montarLab();
})();
